import {
	NgModule
} from '@angular/core';
import {
	RouterModule,
	Routes
} from '@angular/router';

import {
	AboutUsComponent
} from '@main/about-us/components';
import {
	HomeComponent
} from '@main/home/components';
import {
	ProductComponent
} from '@main/products/components';
import {
	ContactComponent
} from '@main/contact/components';

import {
	CustomPreloadingStrategy
} from './custom-preloading-strategy';

const routes: Routes = [
	{
		path		: '',
		component	: HomeComponent,
	},
	{
		path		: 'products',
		component	: ProductComponent,
	},
	{
		path		: 'about-us',
		component	: AboutUsComponent,
	},
	{
		path		: 'contact',
		component	: ContactComponent,
	},
	{
		path		: '**',
		redirectTo	: '/',
		pathMatch	: 'full',
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(
			routes,
			{
				preloadingStrategy: CustomPreloadingStrategy,
				enableViewTransitions: true,
				initialNavigation: 'enabledBlocking',
				useHash: false,
				scrollPositionRestoration: 'top'
			}
		),
	],
	exports		: [ RouterModule ],
	providers	: [ CustomPreloadingStrategy ],
})
export class AppRoutingModules {}
